import React, { useRef } from 'react'
import SideNavLayout from '../Sidenav/SideNavLayout'
import Toast from '../global/toastmessage';
import { useState, useEffect } from 'react';
import api from '../api/api'
import { FiEye, FiEyeOff } from 'react-icons/fi';
import useProfileStore from '../Zustand/useProfileStore';
import { useSelector } from 'react-redux';
import SignatureModal from '../forms/Signaturemodal';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenNib, faUpload } from "@fortawesome/free-solid-svg-icons";
const Profilepage = () => {
     const [avatarFile, setAvatarFile] = useState(null);
      const [avatarPreview, setAvatarPreview] = useState(null);
      const [signpreview,setSignPreview]=useState(null)

      const imageUrl = useProfileStore((state) => state.imageUrl);
      const setImageUrl = useProfileStore((state) => state.setImageUrl);
      const user = useSelector((state) => state.user.userDetails);
      const fileInputRef = useRef(null);
      const [error, setError] = useState(null);    
      
           const [signaturemodal,setSignatureModal]=useState(false)
      const [formData, setFormData] = useState({
        firstname: '',
        lastname: '',
        phone: '',
        email: '',
        username: '',
        ipadId: null,
        gender: '',
        status: '',
      });
      const [originalData, setOriginalData] = useState({
        firstname: '',
        lastname: '',
        phone: '',
        email: '',
        username: '',
        ipadId: null,
        gender: '',
        status: '',
      });
    
      const [toast, setToast] = useState({
        open: false,
        message: '',
        severity: 'success' 
      });
    
      const showToast = (message, severity = 'success') => {
        setToast({
          open: true,
          message,
          severity
        });
      };
    
      const [passwordData, setPasswordData] = useState({
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
      });
      
      const [passwordErrors, setPasswordErrors] = useState({
        newPassword: '',
        confirmPassword: '',
      });
    
      const [passwordVisibility, setPasswordVisibility] = useState({
        currentPassword: false,
        newPassword: false,
        confirmPassword: false,
      });
    
      const [isSaving, setIsSaving] = useState(false);
      const [isUpdatingPassword, setIsUpdatingPassword] = useState(false);
    
      const togglePasswordVisibility = (field) => {
        setPasswordVisibility(prev => ({
          ...prev,
          [field]: !prev[field]
        }));
      };
    
      const handleCloseToast = () => {
        setToast(prev => ({ ...prev, open: false }));
      };
const checkProfileImage = (userId) => {
  const cacheBuster = new Date().getTime(); // or Math.random()
  const profileImgUrl = `https://hub2.ntactops.com/ntact/files/user_profiles/${userId}_profile.png?cb=${cacheBuster}`;
  const img = new Image();

  img.onload = () => {
    setImageUrl(profileImgUrl);
    setAvatarPreview(profileImgUrl);
  };

  img.onerror = () => {
    setImageUrl(null);
    setAvatarPreview(null);
  };

  img.src = profileImgUrl; // triggers load
};

const checksignatureImage = (userId) => {
  const cacheBuster = new Date().getTime();
  const signatureUrl = `https://hub2.ntactops.com/ntact/files/user_signatures/${userId}_signature.png?cb=${cacheBuster}`;
  const img = new Image();

  img.onload = () => {
    setSignPreview(signatureUrl);
  };

  img.onerror = () => {
    setSignPreview(null);
  };

  img.src = signatureUrl; // triggers load
};


      useEffect(() => {
  if (user?.id) {
    checkProfileImage(user.id);
    checksignatureImage(user.id);
  }
}, [user]);

    
   const handleAvatarChange = async (e) => {
  const file = e.target.files?.[0];
  if (!file) return;

  // ✅ Validate image type
  if (!file.type.startsWith("image/")) {
    showToast("Please select a valid image file", "error");
    return;
  }

  // ✅ Show preview
  setAvatarFile(file);
  setAvatarPreview(URL.createObjectURL(file));

  try {
    // ✅ Convert file to Base64
    const base64 = await toBase64(file);

    // ✅ Send base64 string to your upload function
    await uploadAvatar(base64, "profile");
  } catch (error) {
    console.error("Base64 conversion failed:", error);
    showToast("Failed to process image", "error");
  }
};
const HandleSignature = async (x) => {
  if (!x) return;

  // ✅ Check file type
  if (!x.type.startsWith("image/")) {
    showToast("Please select a valid image file", "error");
    return;
  }

  try {
    // ✅ Convert file to Base64
    const base64 = await toBase64(x);

    // ✅ Call uploadAvatar with Base64 data
    await uploadAvatar(base64, "signature");

    showToast("Signature uploaded successfully!", "success");
  } catch (error) {
    console.error("Error converting signature to Base64:", error);
    showToast("Failed to upload signature", "error");
  }
};


// ✅ Helper to convert file to Base64
// ✅ Convert file to Base64 string (without MIME prefix)
const toBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64String = reader.result.split(',')[1]; // remove prefix
      resolve(base64String);
    };
    reader.onerror = (error) => reject(error);
  });
};


   
      const handleFileUpload = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      HandleSignature(file); // ✅ call your upload function
    }
  };

  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };
    
      const uploadAvatar = async (avatarFile,type) => {
        if (!avatarFile) {
          showToast("Please select an image file to upload.", "error");
          return false;
        }
      
     
        const formData = {}
        if(type==='profile'){
formData.profile_picture= avatarFile
        }else if(type==='signature'){
formData.signature_picture= avatarFile
        }
      
        try {
            const token = sessionStorage.getItem("accessToken");  
   const response = await api.put(
    `/v1/users/upload-images?user_id=${user.id}`,
    formData,
    {
      headers: {
        'accept': 'application/json', 
        'Content-Type': 'application/json',
      },
    }
  );
          return true
        } catch (error) {
          console.error("Upload failed", error);
          showToast("Error uploading profile picture", "error");
          return false;
        }finally{
          if(type==='signature'){
 checksignatureImage(user.id);
          }
          if (type === 'profile') {
      // ✅ Force-refresh profile image with cache-busting timestamp
      const cacheBuster = new Date().getTime();
      const newUrl = `https://hub2.ntactops.com/ntact/files/user_profiles/${user.id}_profile.png?cb=${cacheBuster}`;
      setImageUrl(newUrl); // updates Zustand globally
      setAvatarPreview(newUrl); // updates local preview instantly
    }
      window.location.reload();
        }
      };
      
    

      

      useEffect(() => {
          fetchUserData();
    
      
      }, []);
   
      const fetchUserData = async () => {
        try {     
              const response = await api.post(`/v1/users/${user?.id}`);    
          if (response.data) {
            setFormData({
              firstname: response.data.firstname || '',
              lastname: response.data.lastname || '',
              phone: response.data.phone || '',
              email: response.data.email || '',
              username: response.data.username || '',
              ipadId: response.data.ipadid || null,
              gender: response.data.gender,
              status: response.data.status,
            });
            setOriginalData({
              firstname: response.data.firstname || '',
              lastname: response.data.lastname || '',
              phone: response.data.phone || '',
              email: response.data.email || '',
              username: response.data.username || '',
              ipadId: response.data.ipadid || null,
              gender: response.data.gender ,
              status: response.data.status,
            })
          }
        } catch (error) {
          console.error('Error fetching user data:', error);
        }
      };
  
    
      if (error) {
        return <div className="error">Error: {error}</div>;
      }
      
      const handleSave = async () => {
        try {
          setIsSaving(true);
          const changedFields = {}; 
          for (const key in formData) {
            if (formData[key] !== originalData[key]) {
              changedFields[key] = formData[key];
            }
          }
          if (Object.keys(changedFields).length === 0) {
            showToast('No changes to save', 'info');
            return;
          }
          const response = await api.put(`/v1/users/${user.id}`,changedFields)      
          if (response.status === 200) {
   fetchUserData()
            showToast(response.data?.message || 'User Updated Successfully');
         
          }
        } catch (error) {
          console.error('Error updating user data:', error);
          showToast(error.response?.data?.message || 'Failed to update profile. Please try again');
        } finally {
          
          setIsSaving(false);
        }
      };
      
      const validatePasswordChange = () => {
        const errors = {
          newPassword: '',
          confirmPassword: ''
        };
    
        if (passwordData.newPassword.length < 6) {
          errors.newPassword = 'Password must be at least 6 characters';
        }
    
        if (passwordData.newPassword !== passwordData.confirmPassword) {
          errors.confirmPassword = 'Passwords do not match';
        }
    
        setPasswordErrors(errors);
        return !errors.newPassword && !errors.confirmPassword;
      };
    
      const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
      };
    
      const handlePasswordChange = (e) => {
        const { name, value } = e.target;
        setPasswordData((prev) => ({ ...prev, [name]: value }));
      };
    
      const handleChangePassword = async () => {
        if (!validatePasswordChange()) {
          showToast('Please Enter Password', 'error');
          return;
        }
    
        try {
          setIsUpdatingPassword(true);
       
          const payload = {
            currentpassword: passwordData.currentPassword,
            newpassword: passwordData.newPassword,
            confirmpassword: passwordData.confirmPassword
          };
    
          const response = await api.put(`/v1/users/${user?.id}/changepassword`, payload);
    
          if (response.status === 200) {
            showToast(response.data?.message || 'Password updated successfully');
            setPasswordData({
              currentPassword: '',
              newPassword: '',
              confirmPassword: ''
            });
       
          }
          if (response.status === 201) {
            showToast(
              response.message || 'New password must be different from the current password',
              'error' 
            );
            setPasswordData({
              currentPassword: '',
              newPassword: '',
              confirmPassword: ''
            });
          }
        } catch (error) {
          console.error('Error changing password:', error);
          showToast(error.response?.data?.message || 'Failed to change password. Please try again', 'error');
        } finally {
          setIsUpdatingPassword(false);
        }
      };
      
  return (
    <SideNavLayout>
      <div className='max-h-[90vh] overflow-y-auto' style={{scrollbarWidth:'none'}}>
  <div className='custom-scrollbar mx-10 border bg-[white] rounded-xl  p-10 ' >
           <div className="col-span-2 flex flex-col items-center gap-2">
        <div
  className="w-24 h-24 rounded-full bg-gray-200 overflow-hidden cursor-pointer border-2 border-gray-300"
  onClick={() => document.getElementById("avatarInput").click()}
>
  {avatarPreview ? (
    <img
      src={avatarPreview}
      alt="Profile"
      className="w-full h-full object-cover"
    />
  ) : (
    <div className="w-full h-full flex items-center justify-center text-gray-500 text-sm">
      Click to upload
    </div>
  )}

  <input
    id="avatarInput"
    type="file"
    accept="image/*"
    onChange={handleAvatarChange}
    className="hidden"
  />
</div>

           </div>
 
           <div className="grid grid-cols-1 md:grid-cols-2 gap-4 px-4 mt-4">
             <div>
               <label className="block text-sm font-medium text-start mb-2">Firstname</label>
               <input
                 name="firstname"
                 value={formData.firstname}
                 onChange={handleInputChange}
                 className="w-full border rounded px-3 py-2 focus:outline-none"
               />
             </div>
             <div>
               <label className="block text-sm font-medium text-start mb-2">Lastname</label>
               <input
                 name="lastname"
                 value={formData.lastname}
                 onChange={handleInputChange}
                 className="w-full border rounded px-3 py-2"
               />
             </div>
             <div>
               <label className="block text-sm font-medium text-start mb-2">Phone</label>
               <input
                 name="phone"
                 value={formData.phone}
                 onChange={handleInputChange}
                 className="w-full border rounded px-3 py-2"
               />
             </div>
             <div>
               <label className="block text-sm font-medium text-start mb-2">Email</label>
               <input
                 name="email"
                 value={formData.email}
                 onChange={handleInputChange}
                 className="w-full border rounded px-3 py-2"
               />
             </div>
             <div>
               <label className="block text-sm font-medium text-start mb-2">Username</label>
               <input
                 name="username"
                 autoComplete='off'
                 value={formData.username}
                 readOnly
                 className="w-full border rounded px-3 py-2 bg-gray-100"
               />
             </div>
             <div>
               <label className="block text-sm font-medium text-start mb-2">Ipad ID</label>
               <input
                 name="ipadId"
                 value={formData.ipadId}
                 onChange={handleInputChange}
                 className="w-full border rounded px-3 py-2"
               />
             </div>
             <div>
               <label className="block text-sm font-medium text-start mb-2">Gender</label>
               <select
                 name="gender"
                 value={formData.gender}
                 onChange={handleInputChange}
                 className="w-full border rounded px-3 py-2"
               >
                 <option value='M'>Male</option>
                 <option value='F'>Female</option>
                 <option value='O'>Other</option>
               </select>
             </div>
             <div>
  <label className="block text-sm font-medium text-start mb-2">Status</label>
  <select
    name="status"
    value={formData.status}
    onChange={handleInputChange}
    className="w-full border rounded px-3 py-2"
  >
    <option value="A">Active</option>
    <option value="I">Inactive</option>
  </select>
</div>

           </div>
           
           <div className='flex w-full justify-center px-2'>
             <button 
               onClick={handleSave}
               disabled={isSaving}
               className={`mt-6 px-6 py-2 bg-red-800 text-white rounded hover:bg-blue-900 ${isSaving ? 'opacity-50 cursor-not-allowed' : ''}`}
             >
               {isSaving ? 'Saving...' : 'Save'}
             </button>
           </div>
 
           <hr className="my-6" />
      <div className="text-start">
      <div
        className="d-flex flex-row flex-wrap gap-3 border rounded-3 p-3 shadow-sm"
        style={{
          backgroundColor: "#f9f9f9",
          borderColor: "#e0e0e0",
        
        }}
      >
        <div className="fw-semibold text-dark mb-2">
          Digital Signature :
        </div>

    <div className='flex flex-row gap-4'>

 <div
          className="d-flex align-items-center gap-2 text-primary fw-medium"
          onClick={handleUploadClick}
          style={{
            cursor: "pointer",
            transition: "color 0.2s ease-in-out",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.color = "#0d6efd")}
          onMouseLeave={(e) => (e.currentTarget.style.color = "#0d6efd")}
        ><input
  type="file"
  ref={fileInputRef}
  accept="image/*"
  className="hidden"
  onChange={handleFileUpload}
/>
          <FontAwesomeIcon  icon={faUpload} />
          <span>{signpreview ?"Upload New":"Upload"}</span>
        </div>

    <span className="text-secondary">or</span>
        {/* Open Signature Modal */}
        <div
          className="d-flex align-items-center gap-2 text-success fw-medium"
          onClick={() => setSignatureModal(true)}
          style={{
            cursor: "pointer",
            transition: "color 0.2s ease-in-out",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.color = "#198754")}
          onMouseLeave={(e) => (e.currentTarget.style.color = "#198754")}
        >
          <FontAwesomeIcon icon={faPenNib} />
          <span>Sign Now</span>
        </div>
    </div>

    
<div className="flex items-center gap-3">
  {signpreview ? (
    <img
      src={signpreview}
      alt="Signature Preview"
      className="w-10 h-10 mt-2 object-cover rounded border border-gray-300"
    />
  ) : (
  <></>
  )}

</div>

      </div>
    </div>
       <hr className="my-6" />
           <h2 className="text-lg font-semibold font-inter mb-4 text-red-800">Change Password</h2>
 
           <div className="grid grid-cols-1 md:grid-cols-3 gap-4 px-2">
             <div className="relative">
               <label className="block text-sm font-medium text-start mb-2">Current Password</label>
               <div className="relative">
                 <input
                   type={passwordVisibility.currentPassword ? "text" : "password"}
                 autoComplete='new-password'
                   name="currentPassword"
                   value={passwordData.currentPassword}
                   onChange={handlePasswordChange}
                   className="w-full border rounded px-3 py-2 pr-10"
                   placeholder="Current Password"
                 />
                 <button
                   type="button"
                   className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-600"
                   onClick={() => togglePasswordVisibility('currentPassword')}
                 >
                   {passwordVisibility.currentPassword ? <FiEyeOff /> : <FiEye />}
                 </button>
               </div>
             </div>
             
             <div className="relative">
               <label className="block text-sm font-medium text-start mb-2">New Password</label>
               <div className="relative">
                 <input
                   type={passwordVisibility.newPassword ? "text" : "password"}
                   name="newPassword"
                   autoComplete='off'
                   value={passwordData.newPassword}
                   onChange={handlePasswordChange}
                   className={`w-full border rounded px-3 py-2 pr-10 ${passwordErrors.newPassword ? 'border-red-500' : ''}`}
                   placeholder="New Password"
                 />
                 <button
                   type="button"
                   className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-600"
                   onClick={() => togglePasswordVisibility('newPassword')}
                 >
                   {passwordVisibility.newPassword ? <FiEyeOff /> : <FiEye />}
                 </button>
               </div>
               {passwordErrors.newPassword && (
                 <p className="text-red-500 text-xs mt-1">{passwordErrors.newPassword}</p>
               )}
             </div>
             
             <div className="relative">
               <label className="block text-sm font-medium text-start mb-2">Confirm Password</label>
               <div className="relative">
                 <input
                   type={passwordVisibility.confirmPassword ? "text" : "password"}
                   name="confirmPassword"
                   autoComplete='off'
                   value={passwordData.confirmPassword}
                   onChange={handlePasswordChange}
                   className={`w-full border rounded px-3 py-2 pr-10 ${passwordErrors.confirmPassword ? 'border-red-500' : ''}`}
                   placeholder="Confirm Password"
                 />
                 <button
                   type="button"
                   className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-600"
                   onClick={() => togglePasswordVisibility('confirmPassword')}
                 >
                   {passwordVisibility.confirmPassword ? <FiEyeOff /> : <FiEye />}
                 </button>
               </div>
               {passwordErrors.confirmPassword && (
                 <p className="text-red-500 text-xs mt-1">{passwordErrors.confirmPassword}</p>
               )}
             </div>
           </div>
           
           <div className='flex w-full justify-center'>
             <button
               onClick={handleChangePassword}
               disabled={isUpdatingPassword}
               className={`mt-6 px-6 py-2 bg-red-800 text-white rounded hover:bg-blue-900 ${isUpdatingPassword ? 'opacity-50 cursor-not-allowed' : ''}`}>
               Update Password
             </button>
           </div>
         </div>
      </div>
      
       <SignatureModal isModal={signaturemodal} setModal={setSignatureModal} onSave={HandleSignature} />
         <Toast
        open={toast.open}
        onClose={handleCloseToast}
        severity={toast.severity}
        message={toast.message}
        autoHideDuration={6000}
      />
    </SideNavLayout>
 
  )
}

export default Profilepage
